import styled from 'styled-components'

/**
 * Two-column detail layout: the request itself stays the main column, context that a reviewer
 * consults rather than reads sits in a fixed rail beside it. Below the breakpoint the rail stacks
 * underneath, because at that width a 450px column leaves the request too narrow.
 */
export const Layout = styled.div`
  display: grid;
  gap: ${({ theme }) => theme.size.space['06']};
  grid-template-columns: minmax(0, 1fr) 450px;
  align-items: start;
  width: 100%;

  @media (max-width: 1200px) {
    grid-template-columns: minmax(0, 1fr);
  }
`

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.size.space['04']};
  min-width: 0;
`

export const Aside = styled.aside`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.size.space['04']};
  min-width: 0;
  position: sticky;
  top: ${({ theme }) => theme.size.space['06']};
`
